import { DateTime } from 'luxon';
import userState from '@/store/user';
import { FieldChildrenProp } from '@/services/hexabase/types';
import { VAutocomplete } from 'vuetify/lib';

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace headerForm {
  export const EstimateInfomationHeader: Array<FieldChildrenProp> = [
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '見込顧客番号',
      'name': '見込顧客番号',
      'display_id': '見込顧客番号',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'見込顧客番号',
        'labelText':'見込顧客番号',
        'name':'見込顧客番号',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':1,
      'sizeY':1,
      'col':0,
      'row':0,
      'show': true,
    },
    {
      'search': true,
      'show_list': true,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 2,
      'full_text': false,
      'unique': true,
      'min_value': '',
      'max_value': '',
      'field_id': '顧客名',
      'name': '顧客名',
      'display_id': '顧客名',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'顧客名',
        'labelText':'顧客名',
        'name':'顧客名',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':1,
      'sizeY':1,
      'col':1,
      'row':0,
      'show': true,
    },
    {
      'search': true,
      'show_list': true,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 2,
      'full_text': false,
      'unique': true,
      'min_value': '',
      'max_value': '',
      'field_id': '案件名',
      'name': '案件名',
      'display_id': '案件名',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'案件名',
        'labelText':'案件名',
        'name':'案件名',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':1,
      'sizeY':1,
      'col':2,
      'row':0,
      'show': true,
    },
    {
      'search': true,
      'show_list': true,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 2,
      'full_text': false,
      'unique': true,
      'min_value': '',
      'max_value': '',
      'field_id': '見積番号',
      'name': 'estimate_id',
      'display_id': 'estimate_id',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'見積番号',
        'labelText':'見積番号',
        'name':'estimate_id',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':1,
      'sizeY':1,
      'col':3,
      'row':0,
      'show': true,
    },
    {
      'search': true,
      'show_list': true,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 2,
      'full_text': false,
      'unique': true,
      'min_value': '',
      'max_value': '',
      'field_id': 'サービス種別',
      'name': 'サービス種別',
      'display_id': 'サービス種別',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'サービス種別',
        'labelText':'サービス種別',
        'name':'サービス種別',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':1,
      'sizeY':1,
      'col':0,
      'row':1,
      'show': true,
    },
    {
      'search': true,
      'show_list': true,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 2,
      'full_text': false,
      'unique': true,
      'min_value': '',
      'max_value': '',
      'field_id': '支払情報',
      'name': 'payment_information',
      'display_id': 'payment_information',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'支払情報',
        'labelText':'支払情報',
        'name':'payment_information',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':1,
      'sizeY':1,
      'col':1,
      'row':1,
      'show': true,
    },
    {
      'search': true,
      'show_list': true,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 2,
      'full_text': false,
      'unique': true,
      'min_value': '',
      'max_value': '',
      'field_id': '見積作成者',
      'name': '見積作成者',
      'display_id': '見積作成者',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'見積作成者',
        'labelText':'見積作成者',
        'name':'見積作成者',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':1,
      'sizeY':1,
      'col':2,
      'row':1,
      'show': true,
    },
    {
      'search': true,
      'show_list': true,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 2,
      'full_text': false,
      'unique': true,
      'min_value': '',
      'max_value': '',
      'field_id': '見積登録日',
      'name': '見積登録日',
      'display_id': '見積登録日',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'見積登録日',
        'labelText':'見積登録日',
        'name':'見積登録日',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':1,
      'sizeY':1,
      'col':3,
      'row':1,
      'show': true,
    }
  ];
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace optionalForm {
  export const EstimateSubjectNames: Array<FieldChildrenProp> = [
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '見積件名',
      'name': '見積件名',
      'display_id': 'estimate_subject',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'見積件名',
        'labelText':'見積件名',
        'name':'estimate_subject',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':2,
      'sizeY':1,
      'col':0,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '見積版名',
      'name': 'estimate_version_name',
      'display_id': 'estimate_version_name',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'見積版名',
        'labelText':'見積版名',
        'name':'estimate_version_name',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':3,
      'sizeY':1,
      'col':3,
      'row':0,
      'show': true,
    }
  ];

  export const EstimateOAInformations: Array<FieldChildrenProp> = [
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '見積有効期限',
      'name': 'estimate_expiration_date',
      'display_id': 'estimate_expiration_date',
      'dataType': 'text',
      'component': 'DatePickerArea',
      'props':{
        'labelName':'見積有効期限',
        'labelText':'見積有効期限',
        'name':'estimate_expiration_date',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': '',
        'format': 'yyyy/MM/dd'
      },
      'sizeX':1,
      'sizeY':1,
      'col':0,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '見積ステータス',
      'name': 'Status',
      'display_id': 'Status',
      'dataType': 'status',
      'component': 'StatusBox',
      'props':{
        'displayStatus' : '',
        'labelName':'見積ステータス',
        'name':'estimate_status',
//        'placement': 'horizontal'
      },
      'sizeX':1,
      'sizeY':1,
      'col':1,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '見積登録日',
      'name': 'estimate_registration_date',
      'display_id': 'estimate_registration_date',
      'dataType': 'text',
      'component': 'DatePickerArea',
      'props':{
        'labelName':'見積登録日',
        'labelText':'見積登録日',
        'name':'estimate_registration_date',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': '',
        'format': 'yyyy/MM/dd'
      },
      'sizeX':1,
      'sizeY':1,
      'col':2,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '見積更新日',
      'name': 'estimate_update_date',
      'display_id': 'estimate_update_date',
      'dataType': 'text',
      'component': 'DatePickerArea',
      'props':{
        'labelName':'見積更新日',
        'labelText':'見積更新日',
        'name':'estimate_update_date',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': '',
        'format': 'yyyy/MM/dd'
      },
      'sizeX':1,
      'sizeY':1,
      'col':3,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '受注確度',
      'name': 'order_accuracy',
      'display_id': 'order_accuracy',
      'dataType': 'select',
      'component': 'SelectArea',
      'props': {
        'name': 'order_accuracy',
        'label': '受注確度',
        'selectData': [],
        'isDisabled': true
      },
      'sizeX':1,
      'sizeY':1,
      'col':4,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      'field_id': 'リース会社',
      'name': 'leasing_company_id',
      'display_id': 'leasing_company_id',
      'dataType': 'text',
      'component': 'MasterSelectMultiSetControl',
      'dblookup': 'm_rate',
      'props': {
        columns: [],
        body: [],
        name: 'leasing_company_id',
        value: '',
        dialogTitle: 'リース会社',
        searchLargeItemData: {
          findItemName:'leasing_company_id',
          setItemValue:'leasing_company_id',
          setItemText:'leasing_company_id'
        },
        searchSmallItemData: {
          findItemName:'contract_months_calculation_disp',
          setItemValue:'contract_months_calculation_disp',
          setItemText:'contract_months_calculation_disp'
        },
        labelName: ['リース会社名', '契約月数'],
        freeFormatLabelName: '料率',
        freeFormatLabelDisplayId: 'rate',
        outPutData: [
          {
            label: 'リース会社',
            name: 'leasing_company_id',
            value: '',
            isReadOnly: true,
            isDisabled: true
          }
        ],
        isDisabled: true,
        isBtnVisible: false,
        getButtonName: '検索'
      },
      'sizeX':1,
      'sizeY':1,
      'col':0,
      'row':1,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '契約月数',
      'name': 'contract_months',
      'display_id': 'contract_months',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'契約月数',
        'labelText':'契約月数',
        'name':'contract_months',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': '',
        'inputType': 'number'
      },
      'sizeX':1,
      'sizeY':1,
      'col':1,
      'row':1,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '料率',
      'name': 'rate',
      'display_id': 'rate',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'料率',
        'labelText':'料率',
        'name':'rate',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'estimate_rate',
        'value': '',
        'inputType': 'number'
      },
      'sizeX':1,
      'sizeY':1,
      'col':2,
      'row':1,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '月額リース料',
      'name': 'monthly_lease_fee',
      'display_id': 'monthly_lease_fee',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'月額リース料',
        'labelText':'月額リース料',
        'name':'monthly_lease_fee',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': '',
        'inputType': 'number'
      },
      'sizeX':1,
      'sizeY':1,
      'col':3,
      'row':1,
      'show': true,
    }
  ];

  export const EstimateGeneralInformations: Array<FieldChildrenProp> = [
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '見積有効期限',
      'name': 'estimate_expiration_date',
      'display_id': 'estimate_expiration_date',
      'dataType': 'text',
      'component': 'DatePickerArea',
      'props':{
        'labelName':'見積有効期限',
        'labelText':'見積有効期限',
        'name':'estimate_expiration_date',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': '',
        'format': 'yyyy/MM/dd'
      },
      'sizeX':1,
      'sizeY':1,
      'col':0,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '見積ステータス',
      'name': 'estimate_status',
      'display_id': 'estimate_status',
      'dataType': 'status',
      'component': 'StatusBox',
      'props':{
        'displayStatus' : '',
        'labelName':'見積ステータス',
        'name':'estimate_status',
      },
      'sizeX':1,
      'sizeY':1,
      'col':1,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '見積登録日',
      'name': 'estimate_registration_date',
      'display_id': 'estimate_registration_date',
      'dataType': 'text',
      'component': 'DatePickerArea',
      'props':{
        'labelName':'見積登録日',
        'labelText':'見積登録日',
        'name':'estimate_registration_date',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': '',
        'format': 'yyyy/MM/dd'
      },
      'sizeX':1,
      'sizeY':1,
      'col':2,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '見積更新日',
      'name': 'estimate_update_date',
      'display_id': 'estimate_update_date',
      'dataType': 'text',
      'component': 'DatePickerArea',
      'props':{
        'labelName':'見積更新日',
        'labelText':'見積更新日',
        'name':'estimate_update_date',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': '',
        'format': 'yyyy/MM/dd'
      },
      'sizeX':1,
      'sizeY':1,
      'col':3,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '受注確度',
      'name': 'order_accuracy',
      'display_id': 'order_accuracy',
      'dataType': 'select',
      'component': 'SelectArea',
      'props': {
        'name': 'order_accuracy',
        'label': '受注確度',
        'selectData': [],
        'isReadonly': true,
        'isDisabled': true,
      },
      'sizeX':1,
      'sizeY':1,
      'col':4,
      'row':0,
      'show': true,
    }
  ];

  export const EstimateFJapanInformations: Array<FieldChildrenProp> = [
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '見積有効期限',
      'name': 'estimate_expiration_date',
      'display_id': 'estimate_expiration_date',
      'dataType': 'text',
      'component': 'DatePickerArea',
      'props':{
        'labelName':'見積有効期限',
        'labelText':'見積有効期限',
        'name':'estimate_expiration_date',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': '',
        'format': 'yyyy/MM/dd'
      },
      'sizeX':1,
      'sizeY':1,
      'col':0,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '見積ステータス',
      'name': 'estimate_status',
      'display_id': 'estimate_status',
      'dataType': 'status',
      'component': 'StatusBox',
      'props':{
        'displayStatus' : '',
        'labelName':'見積ステータス',
        'name':'estimate_status',
      },
      'sizeX':1,
      'sizeY':1,
      'col':1,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '見積登録日',
      'name': 'estimate_registration_date',
      'display_id': 'estimate_registration_date',
      'dataType': 'text',
      'component': 'DatePickerArea',
      'props':{
        'labelName':'見積登録日',
        'labelText':'見積登録日',
        'name':'estimate_registration_date',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': '',
        'format': 'yyyy/MM/dd'
      },
      'sizeX':1,
      'sizeY':1,
      'col':2,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '見積更新日',
      'name': 'estimate_update_date',
      'display_id': 'estimate_update_date',
      'dataType': 'text',
      'component': 'DatePickerArea',
      'props':{
        'labelName':'見積更新日',
        'labelText':'見積更新日',
        'name':'estimate_update_date',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': '',
        'format': 'yyyy/MM/dd'
      },
      'sizeX':1,
      'sizeY':1,
      'col':3,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '受注確度',
      'name': 'order_accuracy',
      'display_id': 'order_accuracy',
      'dataType': 'select',
      'component': 'SelectArea',
      'props': {
        'name': 'order_accuracy',
        'label': '受注確度',
        'selectData': [],
        'isReadonly': true,
        'isDisabled': true,
      },
      'sizeX':1,
      'sizeY':1,
      'col':4,
      'row':0,
      'show': true,
    }
  ];

  export const EstimateInformationSummary: Array<FieldChildrenProp> = [
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '定価合計金額(構成表)',
      'name': '定価合計金額(構成表)',
      'display_id': 'composition_table_list_price_total',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'定価合計金額(構成表)',
        'labelText':'定価合計金額(構成表)',
        'name':'定価合計金額(構成表)',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':2,
      'sizeY':1,
      'col':0,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '小計(構成表＋見積明細)',
      'name': '小計(構成表＋見積明細)',
      'display_id': 'total_sales_amount',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'小計(構成表＋見積明細)',
        'labelText':'小計(構成表＋見積明細)',
        'name':'小計(構成表＋見積明細)',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':0,
      'sizeY':0,
      'col':1,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '値引額',
      'name': '値引額',
      'display_id': 'discount_amount',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'値引額',
        'labelText':'値引額',
        'name':'値引額',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':0,
      'sizeY':0,
      'col':2,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '見積合計金額(税別) ',
      'name': '見積合計金額(税別) ',
      'display_id': 'estimated_tax_excluded',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'見積金額(税別)',
        'labelText':'見積金額(税別)',
        'name':'見積金額(税別)',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':2,
      'sizeY':1,
      'col':3,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '消費税率',
      'name': 'sales_tax_rate',
      'display_id': 'sales_tax_rate',
      'dataType': 'number',
      'component': 'InputArea',
      'props':{
        'inputType':'number',
        'labelName':'消費税率',
        'labelText':'消費税率',
        'name':'sales_tax_rate',
        'isReadonly': true,
        'isDisabled': true,
        'rules': 'greater_than_or_equal_to_zero',
        'value': '',
        'min': 0
      },
      'sizeX':0,
      'sizeY':0,
      'col':4,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '消費税額',
      'name': '消費税額',
      'display_id': 'consumption_tax',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'消費税額',
        'labelText':'消費税額',
        'name':'消費税額',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':2,
      'sizeY':1,
      'col':5,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '合計金額(税込)',
      'name': '合計金額(税込)',
      'display_id': 'total_tax_included',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'合計金額(税込)',
        'labelText':'合計金額(税込)',
        'name':'合計金額(税込)',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':2,
      'sizeY':1,
      'col':6,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '営業利益合計',
      'name': '営業利益合計',
      'display_id': 'total_operating_profit',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'営業利益合計',
        'labelText':'営業利益合計',
        'name':'営業利益合計',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':2,
      'sizeY':1,
      'col':4,
      'row':1,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '営業利益率',
      'name': '営業利益率',
      'display_id': 'operating_profit_margin',
      'dataType': 'text',
      'component': 'InputArea',
      'props':{
        'labelName':'営業利益率',
        'labelText':'営業利益率',
        'name':'営業利益率',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':2,
      'sizeY':1,
      'col':5,
      'row':1,
      'show': true,
    }
  ];
  
  export const EstimateDetailSummary: Array<FieldChildrenProp> = [
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '見積合計金額(税別) ',
      'name': '見積合計金額(税別) ',
      'display_id': 'estimated_tax_excluded',
      'dataType': 'number',
      'component': 'InputArea',
      'props':{
        'inputType': 'number',
        'labelName':'小計（税抜）',
        'labelText':'小計（税抜）',
        'name':'小計（税抜）',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':1,
      'sizeY':1,
      'col':3,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '税額',
      'name': '税額',
      'display_id': 'consumption_tax',
      'dataType': 'number',
      'component': 'InputArea',
      'props':{
        'inputType': 'number',
        'divClass': '',
        'labelDivClass': '',
        'labelName':'合計税額',
        'labelText':'合計税額',
        'inputDivClass': '',
        'name':'合計税額',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':1,
      'sizeY':1,
      'col':4,
      'row':0,
      'show': true,
    },
    {
      //** インタフェース利用のために必要なプロパティ、画面では未使用 **//
      'search': false,
      'show_list': false,
      'as_title': false,
      'status': false,
      'fieldIndex': 1,
      'title_order': 1,
      'full_text': false,
      'unique': false,
      'min_value': '',
      'max_value': '',
      // ****** //
      'field_id': '合計金額(税込)',
      'name': '合計金額(税込)',
      'display_id': 'total_tax_included',
      'dataType': 'number',
      'component': 'InputArea',
      'props':{
        'inputType': 'number',
        'labelName':'お見積金額',
        'labelText':'お見積金額',
        'name':'お見積金額',
        'isReadonly': true,
        'isDisabled': true,
        'rules':'',
        'value': ''
      },
      'sizeX':1,
      'sizeY':1,
      'col':5,
      'row':0,
      'show': true,
    }
  ];
}

export const estimateInfomationHeader = headerForm.EstimateInfomationHeader;
export const estimateSubjectNames = optionalForm.EstimateSubjectNames;
export const estimateOAInformations = optionalForm.EstimateOAInformations;
export const estimateGeneralInformations = optionalForm.EstimateGeneralInformations;
export const estimateFJapanInformations = optionalForm.EstimateFJapanInformations;
export const estimateInformationSummary = optionalForm.EstimateInformationSummary;
export const estimateDetailSummary = optionalForm.EstimateDetailSummary;

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace formDefine {
  // APIから取得したDatatypeと使用するべきモジュールコンポーネントをマッピング用
  export const MAPPING: { [k: string]: { component: string; props: string[] } } = {
    text: {
      component: 'InputArea',
      props: ['labelName', 'labelText', 'name']
    },
    number: {
      component: 'InputArea',
      props: ['labelName', 'labelText', 'name' ,'inputType']
    },
    select: {
      component: 'SelectArea',
      props: ['label', 'selectData', 'name']
    },
    textarea: {
      component: 'TextArea',
      props: ['labelName', 'labelText', 'name']
    },
    datetime: {
      component: 'DatePickerArea',
      props: ['labelName', 'labelText', 'name']
    },
    radio: {
      component: 'RadioArea',
      props: ['label', 'selectData', 'name']
    },
    dslookup: {
      component: 'MasterSelectControl',
      props: ['leftSideInputName', 'dialogTitle', 'label', 'isRightSideInputReadOnly']
    },
    status: {
      component: 'SelectArea',
      props: ['label', 'selectData', 'name']
    },
  };
  // 使用するモジュールコンポーネントの各propsにセットするAPIの返り値をマッピング
  export const settingPropsValue: { [k: string]: string } = {
    labelName: 'display_id',
    labelText: 'name',
    label: 'name',
    name: 'display_id',
    selectData: 'options',
    inputType: 'dataType'
  };
}

export const formMapDefineData = formDefine.MAPPING;
export const formMapPropsDefineData = formDefine.settingPropsValue;